"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyShare = void 0;
const constants_1 = require("@dzambalaorg/constants");
const types_1 = require("@framework/types");
exports.emptyShare = {
    contractTemplate: types_1.PonziContractTemplates.SIMPLE,
    payees: [constants_1.wallet],
    shares: [100],
};
//# sourceMappingURL=empty.js.map